import { useEffect, useState } from "react";

export default function Hero() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 200);
    return () => clearTimeout(timer);
  }, []);

  const scrollToContent = () => {
    const el = document.getElementById("content-section");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative w-full h-[100dvh] min-h-[600px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://storage.helloreaddy.io/project_files/ea88366e-535e-456c-a459-3e8bb0b464d0/feecb142-cdcc-4d2f-b0fe-e20f802f504c_compressed_unnamed.webp"
          alt="파주 헤이리 오베르원 메인"
          className="w-full h-full object-cover object-top"
        />
        {/* Dark overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50" />
      </div>

      {/* Title Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full px-4">
        <div
          className={`text-center transition-all duration-1000 ${
            loaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <p className="text-white/80 text-sm md:text-base tracking-[0.3em] mb-4 font-light">
            PREMIUM RESIDENCE
          </p>
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-white font-bold tracking-tight leading-tight mb-3">
            파주 헤이리
          </h1>
          <h2 className="font-heading text-5xl md:text-7xl lg:text-8xl text-white font-bold tracking-tight leading-none mb-6">
            오베르원
          </h2>
          <p className="text-white/70 text-sm md:text-lg tracking-wide max-w-lg mx-auto">
            프리미엄 주거단지의 새로운 기준
          </p>
          <div className="mt-8 flex items-center justify-center gap-4">
            <div className="h-px w-12 bg-white/40" />
            <span className="text-white/60 text-xs tracking-[0.2em]">
              SINCE 2026
            </span>
            <div className="h-px w-12 bg-white/40" />
          </div>
        </div>
      </div>

      {/* Scroll Down Indicator */}
      <button
        onClick={scrollToContent}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 cursor-pointer group"
        aria-label="콘텐츠로 스크롤"
      >
        <span className="text-white/60 text-xs tracking-widest group-hover:text-white/80 transition-colors">
          SCROLL
        </span>
        <div className="w-6 h-10 border-2 border-white/40 rounded-full flex items-start justify-center p-1.5 group-hover:border-white/60 transition-colors">
          <div className="w-1 h-2.5 bg-white/60 rounded-full scroll-mouse-wheel" />
        </div>
        <div className="flex flex-col items-center -mt-1">
          <span className="text-white/40 text-[10px] animate-bounce">▼</span>
        </div>
      </button>
    </section>
  );
}